import { createPinia } from 'pinia';

const piniaStore = createPinia();

export default piniaStore;
